import apiClient from '../client'
import type { DashboardStatsResponse, AnnouncementResponse } from './types'

export const dashboardApi = {
  getStats() {
    return apiClient.get<DashboardStatsResponse>('/api/dashboard/stats', {
      _silent: true,
    })
  },

  getAnnouncements() {
    return apiClient.get<AnnouncementResponse[]>('/api/dashboard/announcements', {
      _silent: true,
    })
  },
}
